import { IMenuItem } from "../interfaces/IMenuItem";

export const getSelectedOptionsTotal = (menuItem: IMenuItem): number => {
    return (menuItem.selectedOptions ?? []).reduce((sum, option) => {
        return sum + (option.additionalPrice ?? 0);
    }, 0);
}

export const getMenuItemUnitPrice = (menuItem: IMenuItem): number => {
    return (menuItem.basePrice ?? menuItem.price ?? 0) + getSelectedOptionsTotal(menuItem);
}

export const getMenuItemLinePrice = (menuItem: IMenuItem): number => {
    return getMenuItemUnitPrice(menuItem) * (menuItem.totalInBasket ?? 0);
}
